import styled from "styled-components";

export const Container = styled.div`
    background-color: ${props => props.theme.colors.background.white};
    min-height: 100vh;
`;
